<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="DomainCategoryEnum.MarketComm" i18n>Market / Comm</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.BusinessManagement" i18n>Business / Management</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.CreaDesign" i18n>Créa / Design</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.RhAdminJuridique" i18n>RH / Admin / Juridique</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.GestionFinance" i18n>Gestion / Finance</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.LogistiqueProduction" i18n>Logistique / Production</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.Tech" i18n>Tech</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.ScienceRdIngenierie" i18n>Science / R&D / Ingénierie</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.SanteSocialCulture" i18n>Santé / Social / Culture</ng-container>
  <ng-container *ngSwitchCase="DomainCategoryEnum.HotellerieRestauration" i18n>Hôtellerie - Restauration</ng-container>
  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
